import React, { useState } from "react";
import Button from "../SelectValue/Button";
import PinInput from "react-pin-input";
import postService from "../../Services/post-service";
import { toast } from "react-toastify";
import Loading from "../SelectValue/Loading";
import Shimmer from '../SelectValue/Shimmer';
import { useNavigate } from "react-router-dom";
function ResetPinPin() {
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);
  const requestId = localStorage.getItem("requestIdr");
  const otp = localStorage.getItem("optreset");
  const navigate = useNavigate();
  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    postService.resetPin(otp, requestId, pin).then(
      (response) => {
        setLoading(false);
        if (response.data.statusCode === 200) {
          toast.success(response.data.description || "Pin reset successful");
          setTimeout(() => navigate("/settings"), 2000);
        } else {
          toast.error(response.data.description || "Failed to reset pin");
        }
      },
      async (error) => {
        setLoading(false);
        const errorMessage =
          error.response?.data?.description ||
          "Server is currently unavailable. Please try again later.";
        toast.error(errorMessage);
      }
    );
  };
  return (
    <div>
      <div className=" mt-10 ">
        {loading ? (
          <div className='mt-5'>
            {/* <p className=' text-[18px] text-back-color2 mb-5  font-[500]'>Resetting PIN...</p> */}
            <Shimmer type="rect" />
            <div className='mt-4'>
              <Shimmer type="text" />
            </div>
          </div>
        ) : (
          <>
            <p className=" mb-3 text-back-color2">Reset your Zouse PIN</p>
            <p className=" mb-3 text-[#808285]">Enter your new 4-Digit Pin </p>
            <div className="  mt-5">
              <div>
                <form onSubmit={onSubmit}>
                  <div className=" w-full flex justify-center">
                    <div className=" my-3">
                      <PinInput
                        length={4}
                        initialValue={pin}
                        secret
                        onChange={(value, index) => {
                          setPin(value);
                        }}
                        type="numeric"
                        inputMode="number"
                        style={{ padding: "8px" }}
                        inputStyle={{
                          borderColor: "#00BC67",
                          backgroundColor: "#FAFBFC",
                          borderRadius: 8,
                        }}
                        inputFocusStyle={{
                          borderColor: "#00BC67",
                          backgroundColor: "#CCF2E1",
                        }}
                        onComplete={(value, index) => {
                          setPin(value);
                        }}
                        autoSelect={true}
                        regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                      />
                    </div>
                  </div>

                  <div className=" grid grid-cols-1 mb-5 mt-6">
                    <Button name="Reset" />
                  </div>
                </form>
                <p className="text-center mt-5 cursor-pointer text-primary-color" onClick={() => navigate("/settings/resetpin/otp")}>
                  Go Back to Change OTP
                </p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ResetPinPin;
